
import Vue from "vue";

export default Vue.extend({
  name: "BGItem",
  props: {
    x: Number,
    y: Number,
    width: Number,
    height: Number,
    isStorm: Boolean,
  },
});
